/**
 * Header Navigation
 *
 * @module app/components/HeaderNavigation
 */
import affix from './Affix';
import BodyStateAdapter from './BodyStateAdapter';
import DeviceDetector from './DeviceDetector';
import InPageNavigation from './InPageNavigation';
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';
import PreferencesProvider from './PreferencesProvider';
import Translator from './Translator';
import UrlTranslator from '../libs/UrlTranslator';
import { get, validateVersion } from '../../utils';

/**
 * Global PubSub reference
 *
 * @type {Object}
 *
 * @private
 */
var pubSub = window.WH.messageBus;

/**
 * Saved PageCommon object
 *
 * @type {Object}
 *
 * @private
 */
var PageCommon = null;

/**
 * Saved PageCommon object
 *
 * @type {Object}
 *
 * @private
 */
var urlTranslator = null;

/**
 * Fetch retry interval for mobile navigation
 *
 * @type {Object}
 *
 * @private
 */
var fetchRetryInterval = 5000;

/**
 * closure for retrieve the method name, only in execution time
 *
 * @returns {Object}
 *
 * @private
 */
var updateSportsMenuHandler = function () {

    return updateSportsMenu;
};

/**
 * Maps the subscribed sub-topics to functions
 *
 * @type {Object}
 *
 * @private
 */
var topicMapper = {
    'sport': updateSportsMenuHandler,
    'page': updateSportsMenuHandler,
};

/**
 * cached jQuery objects
 *
 * @returns {function}
 *
 * @private
 */
var cache = {};

/**
 * Mobile menu ajax request
 * @type {Request}
 */
var mobileMenuRequst = null;

/**
 * Mobile menu request timer
 * @type {Request}
 */
var mobileMenuRequestTimer = null;

/**
 * Mobile menu data present
 * @type {Request}
 */
var mobileMenuDataPresent = false;

/**
 * Sets the elements caches after the DOM is ready
 *
 * @returns {void}
 *
 * @private
 */
var setElementsCache = function setElementsCache() {

    cache = {
        '$header': jQuery('#header'),
        '$footer': jQuery('.footer__main'),
        '$navigationWrapper': jQuery('#localnavigation-affix-top'),
        '$nonMobileNav': jQuery('#localNav'),
        '$sportsNonMobileButtons': jQuery('#localNav')
            .find('a.localnavigation__button-nonmobile'),
        '$toggleNonMobileSports': jQuery('#localnavigationButtonShowMore'),
        '$toggleMobileSports': jQuery('#sports-menu'),
        '$sportsMobileDropdown': jQuery('#localNavigationMobileSports'),
        '$sportsMobileButtons': jQuery('#localNavigationMobileSports')
            .find('a.localnavigation__button-dropdown'),
        '$sportsMobileClose': jQuery('#closeLocalNavigationSportsMobile'),
        '$sportsMobileOverlay': jQuery('#azmenu-overlay'),
        '$languageSelector': jQuery('#languageSelection'),
        '$sportsSeparator': jQuery('#localNavigationMobileSports').find('.separator'),
    };
};

/**
 * Re-Sets the elements caches after the DOM is ready
 *
 * @returns {void}
 *
 * @private
 */
var resetElementsCacheForMobileNav = function () {
    cache = Object.assign(cache, {
        '$sportsMobileDropdown': jQuery('#localNavigationMobileSports'),
        '$sportsMobileButtons': jQuery('#localNavigationMobileSports')
            .find('a.localnavigation__button-dropdown'),
        '$sportsMobileClose': jQuery('#closeLocalNavigationSportsMobile'),
        '$sportsMobileOverlay': jQuery('#azmenu-overlay'),
        '$sportsSeparator': jQuery('#localNavigationMobileSports').find('.separator'),
        '$search': jQuery('#localNavigationMobileSports').find('.quickSearch'),
    });
};

/**
 * Check if element has class -expanded
 *
 * @param {Object} obj jQuery selector or jQuery object
 *
 * @returns {boolean}
 *
 * @private
 */
var isExpanded = function isExpanded(obj) {

    return jQuery(obj).hasClass('-expanded');
};

/**
 * Toggles an -expanded class on the given element, it accepts expanded flag, if it's undefined -
 * then it will call isExpanded function to check.
 *
 * @param  {Object} obj jQuery selector or jQuery object
 * @param  {Boolean} expanded Boolean to say if object is expanded or nor
 *
 * @returns {void}
 *
 * @private
 */
var toggleExpanded = function toggleExpanded(obj, expanded) {

    if (expanded !== undefined) {
        jQuery(obj).toggleClass('-expanded', !expanded);
    } else {

        jQuery(obj).toggleClass('-expanded', !isExpanded(obj));
    }

};

/**
 * Removes -expanded class on the header navigation element.
 *
 * @param {Object} ev jQuery Event Object received from the trigger of the event.
 *
 * @returns {void}
 *
 * @private
 */
var closeHeaderNavigation = function closeHeaderNavigation(ev) {

    if (!jQuery(ev.delegateTarget).hasClass('selected')) {

        cache.$navigationWrapper.removeClass('-expanded');
        toggleSportNumberPrefix(false);
    }
};

/**
 * Closes the account tab if it was opened
 *
 * @returns {void}
 *
 * @private
 */
var closeAccountTab = function closeAccountTab() {

    var accountSection = jQuery('#account-section').find('.account');
    if (accountSection.hasClass('-expanded')) {

        toggleExpanded(jQuery('#header').find('.account-tab__button'), true);
        toggleExpanded(accountSection, true);
    }
};

/**
 * Toggles the products list, top header navigation
 *
 * @returns {void}
 *
 * @private
 */
var productListToggle = function productListToggle() {

    var productsExpanded = isExpanded(this);
    toggleExpanded(this, productsExpanded);

    //before showing the list of products we make sure the account tab is closed
    if (!productsExpanded) {

        closeAccountTab();
    }
    toggleExpanded(jQuery('#productnavigation-mobile'), productsExpanded);
};

/**
 * Toggles the language selection box
 *
 * @returns {void}
 *
 * @private
 */
var languageSelectionToggle = function languageSelectionToggle() {

    toggleExpanded(cache.$languageSelector);
    cache.$languageSelector.height(jQuery('body').height());
};

var fetchMobileMenu = function () {
    if (mobileMenuRequst) {
        mobileMenuRequst.abort();
    }

    mobileMenuRequst = jQuery.get('/fragments/mobileMenu/' + PreferencesProvider.getLocale())
        .then(function (data) {
            cache.$sportsMobileDropdown.html(data);
            resetElementsCacheForMobileNav();
            setupMobSportsNavToggleActions();
            InPageNavigation.init(cache.$sportsMobileDropdown, PageCommon);

            cache.$search
                .off('click.quickSeach')
                .on('click.quickSeach', function () {
                    window.WH.messageBus.publish(MessageBusTopics.SEARCH_OPEN);
                });

            mobileMenuDataPresent = true;
            mobileMenuRequst = null;
        }, function () {
            mobileMenuRequestTimer = setTimeout(fetchMobileMenu, fetchRetryInterval);
            fetchRetryInterval *= 2;
            mobileMenuRequst = null;
        });
};
/**
 * Toggles mobile sports list
 *
 * @returns {void}
 *
 * @private
 */
var toggleMobileSports = function toggleMobileSports() {

    var sportsExpanded = isExpanded(cache.$sportsMobileDropdown);

    clearTimeout(mobileMenuRequestTimer);
    mobileMenuRequestTimer = null;
    if (!sportsExpanded && !mobileMenuDataPresent) {
        fetchMobileMenu();
    }
    toggleExpanded(cache.$toggleMobileSports, sportsExpanded);
    cache.$toggleMobileSports.toggleClass('-active', !sportsExpanded);

    toggleExpanded(cache.$sportsMobileDropdown, sportsExpanded);
    BodyStateAdapter.toggleBodyScrolling(!sportsExpanded);
};

/*** Toggles sports list sub-menu inside the side-menu
 *
 * @returns {void}
 *
 * @private
 */

const openSideBarNavigation = function openSideBarNavigation() {
    window.WH.messageBus.publish(MessageBusTopics.SIDEBAR_NAVIGATION_OPEN, 'a-z-sports-menu');
};

const openMobileSportsUtils = {
    getPlatform: () => DeviceDetector.isNativeiOS() ? 'ios' : 'android',
    minMaxConfig: (platform) =>
        get(window,'whStatic.config.toolbar.sidebarNavigation',{})[platform] || {},
};

/**
 * Open A-Z Sports by different platforms
 *
 * @returns {void}
 *
 * @private
 */
const openMobileSports = function openMobileSports() {

    if (DeviceDetector.isNative()) {
        const platform = openMobileSportsUtils.getPlatform();
        const minMaxConfig = openMobileSportsUtils.minMaxConfig(platform);
        const currentVersion = DeviceDetector.getAppVersion();
        const versionConstraints = {
            min: minMaxConfig.minimumVersion,
            max: minMaxConfig.maximumVersion,
        };

        if (!validateVersion(currentVersion, versionConstraints)) {
            toggleMobileSports();
            return;
        }
    }
    if (window.whStatic.config.enableHeaderNavigationToggleMobileSports) {
        toggleMobileSports();
    } else {
        openSideBarNavigation();
    }
};

/**
 * Toggles non mobile sports list
 *
 * @returns {void}
 *
 * @private*/

var toggleNonMobileSports = function toggleNonMobileSports() {

    var menuExpanded = isExpanded(cache.$navigationWrapper);
    //Toggles non mobile sports menu
    toggleExpanded(cache.$navigationWrapper, menuExpanded);
    //Toggles -/+
    toggleSportNumberPrefix(!menuExpanded);

    affix.refresh();
};

/**
 * Toggles -/+ for more sports button on non mobile nav, depending on expanded state
 *
 * @param {Boolean} expanded Boolean to say if list is expanded or not
 *
 * @returns {void}
 *
 * @private
 */
var toggleSportNumberPrefix = function toggleSportNumberPrefix(expanded) {

    var text = cache.$toggleNonMobileSports.html().slice(1);

    if (expanded) {

        cache.$toggleNonMobileSports.html('-' + text);
    } else {

        cache.$toggleNonMobileSports.html('+' + text);
    }
};

/**
 * Updates the Header Sports Navigation to reflect a page or sport change during the in-page navigation
 *
 * @param {Object} args Args published
 *
 * @returns {void}
 *
 * @private
 */
var updateSportsMenu = function updateSportsMenu(args) {

    var icon = getIconValue(args);
    updateNonMobileSportButtons(icon);
    updateMobileSportButtons(icon);
};

/**
 * Returns icon object with icon name and icon to show name values, depending on provided args
 *
 * @param {Object} args Args published
 *
 * @returns {Object} {
 *                       icon: 'iconname',
 *                       iconToShow: 'iconname'
 *                   }
 *
 * @private
 */
var getIconValue = function getIconValue(args) {

    /**
     * Returns flag indicating whether global page icon or sport-specific one should be used
     *
     * @param {String} page Requested page
     * @param {String} sport Sport related to requested page
     *
     * @returns {Boolean}
     *
     * @private
     */
    var shouldUsePageIcon = function (page, sport) {

        var isPageIcon = {
            'virtual': true,
            'whtv': true,
            'promotions': true,
            'top-bets': (sport === 'apps'), // on sport-specific top-bets we want sport icon and not the page icon
            'home': true,
        };

        return isPageIcon[page];
    };

    /**
     * Returns non sport-specific icon object for the page
     *
     * @param {String} page Requested page
     *
     * @returns {Object}
     *
     * @private
     */
    var getPageIcon = function (page) {

        var pageIcons = {
            'virtual': {
                icon: 'virtual-world',
                iconToShow: 'virtual-world',
            },
            'whtv': {
                icon: 'tv-schedule',
                iconToShow: 'tv-schedule',
            },
            'promotions': {
                icon: 'promotions',
                iconToShow: 'promotions',
            },
            'top-bets': {
                icon: 'most-popular-bets2',
                iconToShow: 'most-popular-bets2',
            },
            'home': {
                icon: 'home',
                iconToShow: 'a-z',
            },
        };

        return pageIcons[page];
    };

    if (shouldUsePageIcon(args.page, args.sport)) {

        return getPageIcon(args.page);
    }

    return {
        icon: Translator.translateSlugToEn(args.sport),
        iconToShow: Translator.translateSlugToEn(args.sport),
    };
};

/**
 * Updates sports buttons for non mobile navigation
 *
 * @param {Object} icon Icon object
 *
 * @returns {void}
 *
 * @private
 */
var updateNonMobileSportButtons = function updateNonMobileSportButtons(icon) {

    var currentSportButton = cache.$sportsNonMobileButtons.find('span.icon-' + icon.icon);

    cache.$sportsNonMobileButtons.removeClass('selected');
    currentSportButton.parent().addClass('selected');
};

/**
 * Updates sports buttons for mobile navigation
 *
 * @param {Object} icon Icon object
 *
 * @returns {void}
 *
 * @private
 */
var updateMobileSportButtons = function updateMobileSportButtons(icon) {

    var currentSportButton = cache.$sportsMobileButtons.find('span.icon-' + icon.icon);
    var iconTitle = getIconTitle(currentSportButton, icon.icon);

    cache.$sportsMobileButtons.removeClass('selected');
    currentSportButton.parent().addClass('selected');

    cache.$toggleMobileSports.find('#sport-mobile-navigation-name').text(iconTitle);
    cache.$toggleMobileSports.find('div.icon-wrapper-left > i')
        .attr('class', 'gaming-icon icon-medium icon-' + icon.iconToShow);
};

/**
 * Returns the values to be used to update the nav buttons
 *
 * @param {Object} currentSportButton jQuery element for current active sport button
 * @param {String} sport Sport name
 *
 * @returns {Object}
 *
 * @private
 */
var getIconTitle = function getIconTitle(currentSportButton, icon) {

    var title;

    if (icon === 'home') {

        title = Translator.translate('components.misc.sidebarLeft.home');
    } else {

        title = currentSportButton.siblings('.capitalize').eq(0).text();
    }

    return title;
};

/**
 * Setup header navigation toggle on click events
 *
 * @returns {void}
 *
 * @private
 */
var setupNavToggleActions = function setupNavToggleActions() {

    setupMobSportsNavToggleActions();

    cache.$toggleNonMobileSports.off('click.toggleNonMobileSports');
    cache.$toggleNonMobileSports.on('click.toggleNonMobileSports', toggleNonMobileSports);

    cache.$header.find('button.product-tab.desktop-hide')
        .off('click.productListToggle')
        .on('click.productListToggle', productListToggle);
    cache.$header.find('.productnavigation-button-selector')
        .off('click.productListToggle')
        .on('click.productListToggle', productListToggle);

    cache.$footer.find('.languageSelectionToggle')
        .off('click.languageSelectionToggle')
        .on('click.languageSelectionToggle', languageSelectionToggle);
    cache.$languageSelector.find('header > a')
        .off('click.languageSelectionToggle')
        .on('click.languageSelectionToggle', languageSelectionToggle);
};

/**
 * Setup header sports navigation toggle on click events
 *
 * @returns {void}
 *
 * @private
 */
var setupMobSportsNavToggleActions = function setupMobSportsNavToggleActions() {

    cache.$toggleMobileSports
        .off('click.toggleMobileSports').on('click.toggleMobileSports', openMobileSports);
    cache.$sportsMobileButtons
        .off('click.toggleMobileSports').on('click.toggleMobileSports', toggleMobileSports);
    cache.$sportsMobileClose
        .off('click.toggleMobileSports').on('click.toggleMobileSports', toggleMobileSports);
    cache.$sportsMobileOverlay
        .off('click.toggleMobileSports').on('click.toggleMobileSports', toggleMobileSports);
    cache.$sportsNonMobileButtons
        .off('click.toggleMobileSports').on('click.closeMobileSports', closeHeaderNavigation);
};


/**
 * Updates sports count for non mobile sports list toggle button
 *
 * @returns {void}
 *
 * @private
 */
var updateNonMobileMoreSportsCount = function updateNonMobileMoreSportsCount() {

    var showMoreHtml, updatedShowMoreHtml;

    try {

        showMoreHtml = cache.$toggleNonMobileSports.html().trim();
    } catch (e) {

        showMoreHtml = '';
    }
    updatedShowMoreHtml = showMoreHtml.replace(/[0-9]+/, calculateHiddenSports());
    cache.$toggleNonMobileSports.html(updatedShowMoreHtml);
};

/**
 * Returns the number of invisible sports.
 *
 * @returns {number}
 *
 * @private
 */
var calculateHiddenSports = function calculateHiddenSports() {

    var sportsMenuWidth = cache.$nonMobileNav.innerWidth();
    var sportsVisible = sportsMenuWidth / cache.$sportsNonMobileButtons.eq(0).outerWidth(true);
    var result = cache.$sportsNonMobileButtons.length - parseInt(sportsVisible, 10);

    return !isNaN(result) ? result : '';
};

/**
 * Subscribes to navigation argument changes
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToArgsChanges = function subscribeToArgsChanges() {

    pubSub.subscribe(MessageBusTopics.NAVIGATION_ARGS, argsChangeListener);
};

/**
 * Listens to argument changes on the subscribed topic
 *
 * @param {string} topic Topic under the update was published
 * @param {Object} args Published updates
 *
 * @returns {void}
 *
 * @private
 */
var argsChangeListener = function argsChangeListener(topic, args) {

    var changedProp = topic.split('.').pop();

    var handler = topicMapper[changedProp];

    if (typeof handler === 'function') {

        handler()(args);
    }
};

/**
 * Listens to pageChanged and if in homepage, sets active class
 *
 * @returns {void}
 *
 * @private
 */
var subHeaderHomeActive = function subHeaderHomeActive() {

    pubSub.subscribe(MessageBusTopics.NAVIGATION_PAGE_CHANGED, function () {
        if (window.WH.sportsbook.sport === 'homepage') {
            jQuery('.subheader__item.home').addClass('-active');
        } else {
            jQuery('.subheader__item.home').removeClass('-active');
        }
    });
};

/**
 * Closes subheader dropdown on link click
 *
 * @returns {void}
 *
 * @private
 */
var subHeaderCloseDropdown = function subHeaderCloseDropdown() {

    jQuery('.subheader__dropdown__item > a').on('click', function () {
        if (!jQuery(this).hasClass('js-stop-close-dropdown')) {
            jQuery(this).closest('.subheader__item').removeClass('-opened')
                .children('.-expanded').removeAttr('style').removeClass('-expanded');
        }
    });
};

const transformToSlug = function toSlug(text) {

    if (text && typeof text === 'string') {
        text = text.replace(/^\s+|\s+$/g, ''); // trim leading/trailing spaces
        text = text.replace(/[ /\\-]+/g, '-'); // replace spaces,slashes and backslashes
        text = text.replace(/[¬`!"£$%^&*()[\]\{}~@:.#';,\?:]+/g, ''); // remove strange chars
    }
    return text;
};

const mergeTranslations = function mergeTranslations(nameTranslations) {
    const slugTranslations = window.WH.i18n.allSlugDict;
    const defaultLocale = 'en-gb';

    Object.keys(slugTranslations.slugs).forEach(function(locale) {
        const key = transformToSlug(nameTranslations[locale]).toLocaleLowerCase();

        slugTranslations.slugs[locale][key] = transformToSlug(nameTranslations[defaultLocale]).toLocaleLowerCase();
    });

    Object.keys(slugTranslations.slugsRev).forEach(function(locale) {
        const key = transformToSlug(nameTranslations[locale]).toLocaleLowerCase();

        slugTranslations.slugsRev[locale][key] = transformToSlug(nameTranslations[defaultLocale]).toLocaleLowerCase();
    });

    return slugTranslations;
};

/**
 * Replace all urls in language dropdown with current url.
 *
 * @returns {void}
 *
 * @private
 */
const changeUrlLocales = () => {
    const languagesList = jQuery('.js-language-list')[0].children;
    const nameTranslations = window.WH.i18n.nameTranslations;
    const translations = nameTranslations ? mergeTranslations(nameTranslations) : window.WH.i18n.allSlugDict;

    jQuery(languagesList).each(function(index, elem) {
        var link = elem.children[0];
        if (link.attributes.href.nodeValue.match('\/betting\/') !== null) {
            const href = urlTranslator.translate(
                decodeURI(window.location.pathname),
                window.WH.i18n.locale,
                link.dataset.locale,
                true,
                {
                    slugTranslations: translations,
                }
            );
            link.href = href;
        }
    });
};


var subHeaderUpdateLanguageLinks = function subHeaderUpdateLanguageLinks() {
    jQuery('a.js-language-button').on('click', changeUrlLocales);
};

/**
 * Get targets horizontal position and set as a new value for headers
 *
 * @returns {void}
 *
 * @private
 */
var setHeadersHorizontalPosition = function setHeadersHorizontalPosition(e) {
    var newHeadersHorizontalPosition = -jQuery(e.target).scrollLeft();
    jQuery('#header, #subheader-desktop').css({ transform: 'translateX(' + newHeadersHorizontalPosition + 'px)' });
};

/**
 * For desktop devices
 * Binds horizontal movement of headers on body scroll event
 *
 * @returns {void}
 *
 * @private
 */
var bindWindowsHorizontalScroll = function bindWindowHorizontalScroll() {
    if (jQuery('#subheader-desktop').length || jQuery('#header .pi-header')){
        jQuery(window).on('scroll', setHeadersHorizontalPosition);
    }
};

/*
 * Await for PIH message-bus topic, changes the urls for the destination language
 *
 * @returns {void}
 *
 * @private
 */
const subscribeToPreIntegratedHeaderLanguageChange = function () {
    pubSub.subscribe(MessageBusTopics.PIH_WH_COMMON_EVENT_HEADER_LANGUAGE_SELECTED, function (topic, locale) {
        let nameTranslations = window.WH.i18n.nameTranslations;
        let translations = nameTranslations ? mergeTranslations(nameTranslations) : window.WH.i18n.allSlugDict;
        const decodedPathName = decodeURI(window.location.pathname);

        const pathname = urlTranslator.translate(
            decodedPathName,
            window.WH.i18n.locale,
            locale,
            true,
            {
                slugTranslations: translations,
            });

        if (!pathname.startsWith(decodedPathName)) {
            window.location.pathname = pathname;
        }
    });
};

/**
 * Calls the required init functions after the DOM is ready
 *
 * @returns {void}
 *
 * @private
 */
var performInit = function performInit() {
    bindWindowsHorizontalScroll();
    setElementsCache();
    setupNavToggleActions();
    updateNonMobileMoreSportsCount();
    subscribeToArgsChanges();
    subHeaderHomeActive();
    subHeaderCloseDropdown();
    subHeaderUpdateLanguageLinks();
    subscribeToPreIntegratedHeaderLanguageChange();
};

/**
 * Public functions.
 *
 * @type {Object}
 */
var api = {

    /**
     * Initialization
     *
     * @returns {Function}
     *
     * @public
     */
    init: function (mockPageCommon) {
        PageCommon = mockPageCommon;
        urlTranslator = new UrlTranslator(window.WH.i18n.urlLocaleDict);
        window.WH.messageBus.subscribe(MessageBusTopics.APP_JS_DOM_READY, performInit);
    },
};

export default api;
